<template>
  <DealersTable />
</template>

<script>
import DealersTable from '@/components/DealersTable'
export default {
  name: 'Dealersview',
  components: {
    DealersTable
  }
}
</script>
